namespace $.$$ {
	$mol_style_define($shm_hitalama_guide_item,{
		minWidth:0,width:'100%',
		Menu:{minWidth:0,width:'100%'},Anchor:{padding:0,minWidth:0,width:'100%'},
		Group:{minWidth:0,width:'100%',whiteSpace:'normal',overflowWrap:'anywhere'},
		Link:{minWidth:0,width:'100%',whiteSpace:'normal',overflowWrap:'anywhere'},
	})
}
